import React, { Fragment, useState } from "react";
import { FormattedMessage, useIntl } from "react-intl";
import {
  getValidationShema,
} from "./constants/validationSchema";
import { ErrorMessage, Field, Form, Formik } from "formik";
import "./styles/Step4Form.scss";
import { useStateMachine } from "little-state-machine";
import { updateAction } from "scenes/ProjectMultiStepForm/store";
import CustomProjectPhotosInput from "./components/CustomProjectPhotosInput";
import ProofImages from "./components/ProofImages";
import useMediaQuery from "utils/hooks/useMediaQuery";
import ResponseModal from "./components/ResponseModal";
import { graphql } from "react-apollo";
import CustomMainProjectPhoto from "./components/CustomMainProjectPhoto";
import { updateProjectInformation } from "../../../Step1/components/Step1Form/mutation";
import proquinalHistory from "services/browser-history";

const Step4Form = ({ updateProjectInformation }) => {
  const intl = useIntl();
  const isMobile = useMediaQuery("(max-width: 992px)");
  const [responseModal, setResponseModal] = useState({
    isVisbile: false,
    modalType: "success",
  });
  const { state, actions } = useStateMachine({ updateAction });

  const initialValues = {
    mainProjectPhoto: state?.mainProjectPhoto || "",
    projectPhotos: state?.projectPhotos || [],
    projectImagesPaths: state?.projectImagesPaths || [],
    projectPhotosPolicy: state?.projectPhotosPolicy || false,
  }

  const handleShowResponseModal = (modalType) => {
    setResponseModal(prevState => ({
      ...prevState,
      isVisbile: !responseModal.isVisbile,
      modalType
    }));
  }
  
  const handleSubmit = (values) => {
    const { projectPhotosPolicy, projectImagesPaths, mainProjectPhoto } = values;

    return updateProjectInformation({
      variables: {
        projectId: state?.projectId,
        imagePaths: projectImagesPaths.map((imgPath) => imgPath),
        mainImagePath: mainProjectPhoto,
        statement: projectPhotosPolicy,
      },
    })
      .then((response) => {
        const { updateProjectData } = response.data;

        if (updateProjectData?.project) {
          actions.updateAction({
            ...state,
            ...values,
            projectId: updateProjectData?.project.id,
          });
          handleShowResponseModal("success");
        }
      })
      .catch((err) => {
        const { graphQLErrors, netWorkError } = err;

        if (graphQLErrors || netWorkError) {
          handleShowResponseModal("error");

          console.error("Error update Project GraphQL:", graphQLErrors);
          console.error("Error update Project Network:", netWorkError);
        }
      });
  };

  const goHome = (modalType) => {
    handleShowResponseModal(modalType);

    if (modalType === "success") {
      actions.updateAction({});
      setTimeout(() => {
        proquinalHistory.push({
          pathname: "/"
        });
      }, 2000);
    }
  };

  return (
    <Fragment>
      <Formik
        onSubmit={handleSubmit}
        initialValues={initialValues}
        validationSchema={getValidationShema(intl)}
        enableReinitialize
      >
        {({ isSubmitting }) => (
          <Form id="step-4-form" onKeyDown={e => e && e.key === "Enter" && e.preventDefault()}>
            <div className="step-0-form__container d-flex flex-column">
              <div className="step-4-description text-center">
                <FormattedMessage
                  id="ProjectStepForm.step4.field.projectPhotos"
                  defaultMessage="Asegúrate que sean fotos originales de óptima calidad, con buena iluminación y que represente el diseño y exclusividad de Spradling<sup>®</sup>. Por favor no utilices capturas de pantalla."
                  values={{
                    sup: (...chunks) => <sup>{chunks}</sup>,
                  }}
                />
              </div>
              <CustomMainProjectPhoto />
              <CustomProjectPhotosInput />
              <ProofImages />
              <div className="proof-images__privacy-policy col-lg-11 text-lg-center mx-auto">
                <Field
                  name="projectPhotosPolicy"
                  type="checkbox"
                  className="d-inline mr-2 mr-lg-3"
                />
                {!isMobile ? (
                  <FormattedMessage
                    id="ProjectStepForm.step4.field.projectPhotosPolicy"
                    defaultMessage="Declaro que la información es veraz, completa y cuenta con las autorizaciones necesarias para su uso y tratamiento según la Ley 1581 de 2012 y normas complementarias."
                  />
                ) : (
                  <FormattedMessage
                    id="ProjectStepForm.step4.field.mobile.projectPhotosPolicy"
                    defaultMessage="He leído y acepto la <strong>política de privacidad</strong>"
                    values={{
                      strong: (...chunks) => (
                        <strong className="m-0 p-0">{chunks}</strong>
                      ),
                    }}
                  />
                )}
                <ErrorMessage
                  className="form-error-message"
                  component="div"
                  name="projectPhotosPolicy"
                />
              </div>
              <button
                type="submit"
                className="step-0-form__submit-btn px-5 py-2 mt-2 mt-lg-4"
                disabled={isSubmitting}
              >
                <FormattedMessage
                  id="ProjectStepForm.button.upload"
                  defaultMessage="Cargar"
                />
              </button>
            </div>
          </Form>
        )}
      </Formik>

      <ResponseModal
        isOpen={responseModal.isVisbile}
        modalType={responseModal.modalType}
        closeModal={handleShowResponseModal}
        goHome={goHome}
      />
    </Fragment>
  );
};

export default graphql(updateProjectInformation, { name: "updateProjectInformation" })(Step4Form);
